import {Subscription} from "rxjs";
import {DatePipe} from "@angular/common";
import {RouterLink} from "@angular/router";
import {Component, inject, Input, OnDestroy, OnInit} from '@angular/core';

import {ToastrService} from "ngx-toastr";
import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

import {appRoutes} from "@numizmat/constants";
import {LoginModalComponent} from "@numizmat/modals";
import {ModalService} from "@numizmat/services/common";
import {UserRatingComponent} from "@numizmat/components";
import {AdCommentApiService} from "@numizmat/services/core";
import {CurrentUser} from "@numizmat/services-models/account";
import {AdCommentResponse} from "@numizmat/services-models/core";
import {CurrentUserStateService} from "@numizmat/services/account";
import {
  AdCommentModalComponent
} from "@numizmat/pages/ad-detail-page/modals/ad-comment-modal/ad-comment-modal.component";

@Component({
  selector: 'nz-comments-section',
  standalone: true,
  imports: [
    UserRatingComponent,
    RouterLink,
    DatePipe
  ],
  templateUrl: './comments-section.component.html',
  styleUrl: './comments-section.component.scss'
})
export class CommentsSectionComponent implements OnInit, OnDestroy {
  @Input() adId!: string;
  @Input() adComments: AdCommentResponse[] = [];
  @Input() isUserBlocked: boolean = false;

  private modalService: ModalService = inject(ModalService);
  private toastrService: ToastrService = inject(ToastrService);
  private adCommentApiService: AdCommentApiService = inject(AdCommentApiService);
  private currentUserStateService: CurrentUserStateService = inject(CurrentUserStateService);

  private loggedIn: boolean = false;

  private subs: Subscription = new Subscription();

  protected readonly appRoutes = appRoutes;

  public ngOnInit(): void {
    this.getCurrentUser();
  }

  public ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  protected onOpenAdCommentModal(adComment?: AdCommentResponse) {
    if (this.loggedIn) {
      const mode = !adComment ? 'create' : 'update';
      const modalRef: NgbModalRef = this.modalService.open(AdCommentModalComponent, {
        scrollable: true
      });
      modalRef.componentInstance.adId = this.adId;
      modalRef.componentInstance.adComment = adComment;
      modalRef.componentInstance.mode = mode;
      if (mode === 'create') {
        const subscription: Subscription = modalRef.componentInstance.emittedData.subscribe({
          next: (data: any) => {
            this.adComments.push(data);
          }
        });
        this.subs.add(subscription);
      } else {
        const subscription: Subscription = modalRef.componentInstance.emittedData.subscribe({
          next: (data: any) => {
            const index = this.adComments.findIndex(x => x.adCommentId == adComment?.adCommentId);
            this.adComments[index].content = data;
          }
        });
        this.subs.add(subscription);
      }
    } else {
      this.modalService.open(LoginModalComponent, {
        scrollable: true
      });
    }
  }

  protected onDeleteComment(adCommentId: string) {
    if (this.loggedIn) {
      this.adCommentApiService.deleteAdComment(adCommentId).subscribe({
        next: response => {
          this.toastrService.success("Успешно изтрихте коментар.");
          const index = this.adComments.findIndex(x => x.adCommentId == adCommentId);
          this.adComments.splice(index, 1);
        }
      });
    } else {
      this.modalService.open(LoginModalComponent, {
        scrollable: true
      });
    }
  }

  private getCurrentUser() {
    const subscription: Subscription = this.currentUserStateService.getCurrentUser().subscribe({
      next: (currentUser: CurrentUser | undefined) => {
        if (!!currentUser) {
          this.loggedIn = currentUser.loggedIn;
        }
      }
    });
    this.subs.add(subscription);
  }
}
